<div
  class="container d-block d-md-flex"
  appMobileView
  [tabs]="{left: 'Article', middle: 'Comments'}"
  *ngIf="(discussion$ | async) as discussion"
>
  <div class="big-column">
    <div class="post-block block">
      <div class="post-top d-flex flex-column flex-md-row align-items-md-center">
        <div class="author d-flex align-items-center">
          <a [profile]="discussion.user">
            <app-avatar
              [src]="discussion.user.icon"
              [placeholder]="discussion.user | initials"
              class="medium right"
            ></app-avatar>
          </a>
          <div>
            <div class="d-flex align-items-center">
              <a [profile]="discussion.user" class="name">{{ discussion.user.name }}</a>
            </div>
            <div class="position"> {{discussion.user.type_name}} </div>
          </div>
        </div>
      </div>
      <div class="post-content">
        <!-- <div class="article-image">
            <img src="/assets/new_img/image%209.png" class="img-fluid">
          </div> -->
        <div class="article-title" [innerHTML]="discussion.name | safeUserInput"> </div>
        <!-- TODO: use quill-view https://stackoverflow.com/a/64437425/6135922 -->
        <div class="article-content app-custom-html">
          <div class="ql-container ql-snow" style="border-width: 0">
            <div class="ql-editor" [innerHTML]="discussion.description | safeUserInput | imagesUrl"> </div>
          </div>
        </div>
        <div class="keywords d-flex flex-wrap">
          <div class="keyword-item"> {{discussion.category.name}} </div>
        </div>
      </div>

      <section class="docs">
        <app-message-doc *ngFor="let doc of discussion.docs" [doc]="doc" (click)="openDoc(doc)"></app-message-doc>
      </section>

      <div class="post-actions d-flex">
        <div class="action d-flex align-items-center">
          <div class="count">{{discussion.post.likes.count}}</div>
          <div class="icon" (click)="likePost(discussion.post.id)">
            <svg viewBox="0 0 20 20">
              <use [attr.href]="discussion.post.likes.count? '#like' : '#like-wb'" />
            </svg>
          </div>
        </div>
        <div class="action null-action d-flex align-items-center">
          <div class="count">{{discussion.post.comments.count}}</div>
          <div class="icon">
            <svg viewBox="0 0 20 20">
              <use [attr.href]="discussion.post.comments.count? '#comment' : '#comment-wb'" />
            </svg>
          </div>
        </div>

        <app-link *ngIf="discussion.is_autor" class="edit" [route]="['discussions', discussion.id, 'edit']">
          <button class="edit-text">Edit</button>
        </app-link>

        <!-- <div class="action null-action d-flex align-items-center">
            <div class="count">{{discussion.post.shared.count}}</div>
            <div class="icon" (click)="share()">
              <svg viewBox="0 0 20 20">
                <use [attr.href]="discussion.post.shared.count? '#share' : '#share-wb'" /></svg>
            </div>
          </div> -->
        <!-- <div class="action d-flex align-items-center ml-auto mr-0">
            <div class="icon">
              <svg viewBox="0 0 20 20">
                <use href="#options" /></svg>
            </div>

            <div class="options-menu">
              <a class="menu-item d-flex" (click)="complaine(discussion.post.id)">
                <div class="icon">
                  <svg viewBox="0 0 15 15">
                    <use href="#sub-complain" /></svg>
                </div>
                Complain
              </a>
              <a class="menu-item d-flex" (click)="delete(discussion.post.id)">
                <div class="icon">
                  <svg viewBox="0 0 15 15">
                    <use href="#sub-delete" /></svg>
                </div>
                Delete
              </a>
            </div>
          </div> -->
      </div>
    </div>

    <div class="d-flex">
      <div class="left-column d-none d-md-block">
        <app-suggested-articles *appHideForGuest [articles]="articles$ | async"></app-suggested-articles>
      </div>

      <div class="middle-column d-md-block">
        <app-posts [posts]="discussionPosts$ | async" [ctx]="postsCtx"></app-posts>
      </div>
    </div>
  </div>
  <ng-container *ngIf="(profileType$ | async) === 'student'">
    <div class="right-column d-none d-xl-block" *appHideForGuest>
      <app-summer-programs-right-bar [programs]="summerPrograms$ | async"></app-summer-programs-right-bar>

      <app-after-school-programs-right-bar [afterSchoolPrograms]="afterSchoolPrograms$ | async">
      </app-after-school-programs-right-bar>

      <app-jobs-right-bar [jobs]="jobs$ | async"></app-jobs-right-bar>
    </div>
  </ng-container>
</div>
